const initialState = {
};

export default (state = initialState) => {
	return state;
};
